module.exports = __webpack_public_path__ + "img/hydroflux_darkmode_interface.fe43943a.png";